export default __webpack_public_path__ + "static/media/gallery-wip-clamp-lever_06.68ca8726.jpg";